import React from "react";
import { ElaborationMessage } from "../../redux/feature/object/remote-elaborations-slice";
import { Checkbox, CheckboxChangeEvent } from "@progress/kendo-react-inputs";
import { MessageElaborationCard } from "./MessageDetailsModal";

export interface MessageDetailsCardProps {
  message: MessageElaborationCard;
  selected?: boolean;
  index: number;
  onCheck: (item: ElaborationMessage, selected: boolean) => void;
}

const checkboxStyles = {
  marginRight: "5px",
};

export const MessageDetailsCard: React.FunctionComponent<MessageDetailsCardProps> = (props) => {
  const { message, index, onCheck } = props;

  function check(e: CheckboxChangeEvent) {
    onCheck(message, e.value);
  }

  return (
    <div className={"shadowedCard"} key={index}>
      <Checkbox
        checked={message.selected}
        size="large"
        rounded="small"
        style={checkboxStyles}
        onChange={(e) => check(e)}
        key={`check-${index}`}
      />
      {message.text}
      <br />
      <p>{message.details}</p>
    </div>
  );
};
